import { render } from "./TaxRatesForm.vue?vue&type=template&id=0e83b05c"
import script from "./TaxRatesForm.vue?vue&type=script&lang=js"
export * from "./TaxRatesForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__